import { Brand } from './brand.types';

export const BRAND: Brand = {
  id: 'demo',
  productName: 'Trainer',
  logo: './assets/demo/logo.svg',
  logoMark: './assets/demo/logo.svg',
  favicon: './assets/demo/favicon.svg',
  loginBackground: false,
  storagePrefix: 'demo',
  supportEmail: '',
  privacyEmail: '',
  showMascot: false,
  showCopyright: false,
  copyrightHolder: '',
  showBilling: false,
  showSocialLogin: false,
};
